import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import Folder from '../store/schema/Folder';
import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import FolderStore from '../store/schema/FolderStore';
import { action } from 'satcheljs/lib/legacy';
import { addFolderInSortedOrderUnderParentFolder } from './localFolderOperations';
import getFullFolderId from '../util/getFullFolderId';
import getFolderTable from '../selectors/getFolderTable';

export default action('addNewFolderToStore')(function addNewFolderToStore(
    folders: FolderStore,
    responseMessage: FolderInfoResponseMessage,
    parentFolderId: string | DistinguishedFolderIdName,
    displayName: string
): Promise<string> {
    let fullParentFolderId = getFullFolderId(parentFolderId);
    let item = responseMessage.Folders[0];
    // Get the parent folder tree type here. This will also become the treetype of the folder currently being added.
    const parentFolderTreeType = getFolderTable().get(parentFolderId).treeType;
    let folder: Folder = {
        ...{
            DisplayName: displayName,
            ParentFolderId: fullParentFolderId,
            childFolderIds: [],
            FolderClass: 'IPF.Note',
            distinguishedFolderId: undefined,
            UnreadCount: 0,
            TotalCount: 0,
            treeType: parentFolderTreeType,
        },
        ...item,
    };

    folders.folderTable.set(item.FolderId.Id, folder);
    addFolderInSortedOrderUnderParentFolder(folder, folders, fullParentFolderId.Id);
    return Promise.resolve(item.FolderId.Id);
});
